export default __webpack_public_path__ + "assets/audios/e82bcaba1066cf17886dd737aed71e0e.mp3";